import { GET_Guarantee_LIST_Register } from "../../../../constants/ActionTypes";
import { zeroPad } from "../../../../util/DaFrameword";


const InitialValue={
    GuaranteeList:[]
}

function GuaranteeRegister(state=InitialValue,action){

    switch (action.type) {
        case GET_Guarantee_LIST_Register:
            return {
                ...state,
                    GuaranteeList:action.payload.map(x=>({
                    id:zeroPad(x.id,8),
                    code:x.code,
                    description:x.description,
                    active:x.active                
                })) 
            }
        default:
           return state
    }  

}

export default GuaranteeRegister;